/* TryHard Controller - Selleasy-Widget
   Geladen von sections/footer.liquid, laeuft also auf jeder Seite.

   Zweck: das erste Wort der Produkttitel in beiden Selleasy-Widgets
   (Warenkorb und Produktseite) in ATC-Blau einfaerben - dauerhaft und ohne
   den Titel zu beschaedigen. Die Widget-Ueberschrift bleibt bewusst
   unberuehrt: dort wiederholt sich das Muster nicht, ein einzelnes blaues
   Wort im Satz liest sich als Link.

   Fuenf Dinge, auf die es ankommt:

   1. Nichts wird neu gebaut. Frueher setzte dieses Skript el.innerHTML aus
      el.textContent zusammen. Damit flog jedes Kind-Element, das kein Text
      ist, lautlos raus - genau das war der verschwundene Emoji. Jetzt wird
      nur der eine Textknoten mit dem ersten Wort aufgeteilt (splitText) und
      das Wort in einen Span gehaengt. Emojis, Icons und Bilder daneben
      bleiben unberuehrt.

   2. Emojis sind keine Woerter. Als erstes Wort gilt der erste Textblock,
      der mindestens einen Buchstaben oder eine Ziffer enthaelt. Steht ein
      Emoji davor, wird es uebersprungen, nicht eingefaerbt.

   3. Breiter Selektor. Die Titel im PDP-Widget bekommen die Klasse
      lb-title-ld nicht, deshalb wird nur auf .lb-card-title geprueft.

   4. Erste Faerbung erst, wenn der Text stabil ist. Ein Element muss
      denselben Text zweimal hintereinander zeigen, bevor es angefasst wird -
      sonst erwischt man einen halb aufgebauten Titel.

   5. Selbstheilend, aber ohne sich selbst zu fressen. Selleasy baut seine
      Kacheln neu auf (Stencil) und entfernt dabei mitunter unseren Span.
      Fehlt er, wird neu gefaerbt; aendert sich der Text, wird vorher sauber
      ausgepackt. Unser eigener Span traegt data-thc-w und wird nie ein
      zweites Mal als Ziel genommen - sonst entstehen verschachtelte Spans.

   Zwei Attribute, zwei Aufgaben:
     data-thc-fw  auf dem Titel. Nur ein Kompatibilitaetssignal: das aeltere
                  Inline-Skript in theme.liquid steigt aus, sobald es
                  gesetzt ist.
     data-thc-w   auf unserem Span um das erste Wort. Daran erkennen wir
                  eigene Arbeit wieder. */
(function () {
  'use strict';

  var BLUE = '#4770DB';
  var TITLE = '.lb-card-title';
  var MARK = 'span[data-thc-w]';

  /* Enthaelt der Textblock einen Buchstaben oder eine Ziffer? Unicode-Klassen
     waeren sauberer, sind aber nicht ueberall da - deshalb mit Rueckfall. */
  var hasLetter;
  try {
    var uni = new RegExp('[\\p{L}\\p{N}]', 'u');
    hasLetter = function (s) { return uni.test(s); };
  } catch (e) {
    var ascii = /[0-9A-Za-zÀ-ɏΆ-ϿЀ-ӿ]/;
    hasLetter = function (s) { return ascii.test(s); };
  }

  /* Ersten Textknoten samt Position des ersten echten Wortes finden.
     Reihenfolge ist Dokumentreihenfolge, also genau das, was man sieht.
     Textknoten innerhalb eines eigenen Spans werden uebergangen. */
  function findWord(el) {
    var walker;
    try {
      walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    } catch (e) {
      return null;
    }
    var node;
    while ((node = walker.nextNode())) {
      var s = node.nodeValue;
      if (!s || !/\S/.test(s)) continue;
      if (node.parentNode && node.parentNode.hasAttribute &&
          node.parentNode.hasAttribute('data-thc-w')) continue;
      var re = /\S+/g;
      var t;
      while ((t = re.exec(s))) {
        if (hasLetter(t[0])) {
          return { node: node, start: t.index, end: t.index + t[0].length };
        }
      }
    }
    return null;
  }

  /* Eigene Spans wieder aufloesen: Inhalt an die Stelle des Spans setzen,
     Span entfernen, danach die Textknoten wieder zusammenfuehren. */
  function unwrap(el) {
    var spans = el.querySelectorAll(MARK);
    if (!spans.length) return;
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      var p = s.parentNode;
      if (!p) continue;
      while (s.firstChild) p.insertBefore(s.firstChild, s);
      p.removeChild(s);
    }
    if (el.normalize) el.normalize();
  }

  function paint(el) {
    if (!el) return;

    var txt = (el.textContent || '').trim();
    if (!txt) return;                             // leer -> Uebergang, abwarten

    // Alles unveraendert und unser Span sitzt noch: nichts zu tun.
    if (el.__thcTxt === txt && el.querySelector(MARK)) return;

    // Stabilitaetspruefung: zweimal derselbe Text, dann erst anfassen.
    if (el.__thcSeen !== txt) { el.__thcSeen = txt; return; }

    if (el.__thcTxt !== txt) unwrap(el);           // Text neu -> alt auspacken

    var hit = findWord(el);
    if (!hit) return;

    if (!el.dataset.thcFw) el.dataset.thcFw = '1';

    var node = hit.node;
    if (hit.end < node.nodeValue.length) node.splitText(hit.end);
    var wordNode = hit.start > 0 ? node.splitText(hit.start) : node;

    var span = document.createElement('span');
    span.setAttribute('data-thc-w', '1');
    span.style.setProperty('color', BLUE, 'important');
    span.appendChild(document.createTextNode(wordNode.nodeValue));
    if (wordNode.parentNode) wordNode.parentNode.replaceChild(span, wordNode);

    el.__thcTxt = txt;
  }

  var queued = false;

  function scan() {
    queued = false;
    var titles = document.querySelectorAll(TITLE);
    for (var i = 0; i < titles.length; i++) paint(titles[i]);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(scan);
    else setTimeout(scan, 16);
  }

  var watched = null;

  function attach() {
    var root = document.querySelector('lb-embed') || document.querySelector('#lb-upsell-dialog');
    if (!root || root === watched) return;
    watched = root;
    try {
      new MutationObserver(schedule).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });
    } catch (e) {}
  }

  try {
    new MutationObserver(function () { attach(); schedule(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  function boot() { attach(); schedule(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  /* Dauerhafter Nachlauf: billig (ein querySelectorAll plus Stringvergleich)
     und faengt alles ab, was der Observer verpasst. Er sorgt auch dafuer, dass
     die Stabilitaetspruefung aus Punkt 4 spaetestens nach einer Sekunde ihren
     zweiten Durchlauf bekommt. */
  setInterval(boot, 1000);
})();